export const comments_3389324 = {"data":{"data":[],"links":{}}}